import * as amplitude from '@amplitude/analytics-browser';
import { sessionReplayPlugin } from '@amplitude/plugin-session-replay-browser';
import { getEnvironmentVariables } from 'services/environment-variables/environment-variables';
import { plugin as engagementPlugin } from '@amplitude/engagement-browser';

export enum AmplitudeEventCategories {
  MM_MENU = 'mm menu',
  MM_ALL_ITEMS = 'mm all items',
  MM_OPTIONS = 'mm options',
  MM_SIDE_PANEL_MENU = 'mm side panel (menu)',
  MM_SIDE_PANEL_ITEMS = 'mm side panel (items)',
  MM_SIDE_PANEL_BUSY_MODE = 'mm side panel (busy mode)',
  MM_SIDE_PANEL_MENU_OPERATING_HOURS = 'mm side panel (menu operating hours)',
  MM_SIDE_PANEL_ALL_ITEMS_OPERATING_HOURS = 'mm side panel (all items operating hours)',
  MM_SIDE_PANEL_PRICING = 'mm side panel (pricing)',
  NAVIGATION = 'navigation',
  BOOST = 'boost'
}

export enum AmplitudeEventProperties {
  APP = 'app',
  APPS = 'apps',
  CATEGORY_NAME = 'categoryName',
  FROM = 'from',
  INCREMENT = 'increment',
  ITEM_NAME = 'itemName',
  ITEM_POS_ID = 'itemPosId',
  MENU_ID = 'menuId',
  MENU_NAME = 'menuName',
  OPTION_NAME = 'optionName',
  OPTION_POS_ID = 'optionPosId',
  POS_NAME = 'posName',
  RESULT = 'result',
  VALUE = 'value',
  VENUE_ID = 'venueId',
  SURGE_REVENUE = 'surgeRevenue',
  ENTITY = 'entity',
  SOURCE = 'source',
  ACTION = 'action'
}

export const initAmplitude = (userId: string): amplitude.Types.AmplitudeReturn<void> => {
  const { REACT_APP_AMPLITUDE_KEY, ENABLE_AMPLITUDE_SESSION_REPLAY } = getEnvironmentVariables();

  const amplitudeInstance = amplitude.init(REACT_APP_AMPLITUDE_KEY, userId, {
    autocapture: false
  });

  if (ENABLE_AMPLITUDE_SESSION_REPLAY) {
    amplitude.add(
      sessionReplayPlugin({
        sampleRate: 1
      })
    );
  }

  amplitude.add(engagementPlugin());

  return amplitudeInstance;
};

interface LogAmplitudeEventParams {
  name: string;
  category: string;
  properties?: Record<string, string | string[] | null>;
}

export const logAmplitudeEvent = ({ name, category, properties }: LogAmplitudeEventParams): void => {
  const mergedProperties = {
    category,
    ...properties
  };
  amplitude.logEvent(name, mergedProperties);
};
